import React from "react";
import ProfileField from "./_ProfileField";

const ProfileForm = ({ EditMode, Fields }) => {
  return (
    <div className="profile-sidebar-form">
      {Fields.map((f, k) => (
        <ProfileField {...{ ...f, EditMode }} key={k} />
      ))}
    </div>
  );
};

export default ProfileForm;
